'use client';

import { useTheme } from 'next-themes';
import type { ComponentProps, CSSProperties } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      duration={5000}
      mobileOffset={{ top: 'calc(var(--sat) + 24px)' }}
      style={
        {
          '--normal-bg': 'color-mix(in oklab, var(--popover) 70%, transparent)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as CSSProperties
      }
      toastOptions={{ classNames: { toast: 'cn-toast backdrop-blur-sm' } }}
      {...props}
    />
  );
};

export { Toaster };
